import { render, staticRenderFns } from "./GenericCareerForm.vue?vue&type=template&id=8ff61b24&scoped=true"
import script from "./GenericCareerForm.vue?vue&type=script&lang=js"
export * from "./GenericCareerForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=8ff61b24&prod&scoped=true&lang=css&external"
import style1 from "./GenericCareerForm.vue?vue&type=style&index=1&id=8ff61b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff61b24",
  null
  
)

export default component.exports